module.exports = "img/icon-context-mute-off.b112ec4.svg";